// extracted by mini-css-extract-plugin
module.exports = {"event-content":"I04SparkleLocationOverview_event-content__S4UUM"};